import { useEffect, useRef, useState } from "react";
import WebViewer from "@pdftron/pdfjs-express-viewer";
import { base64ToArrayBuffer } from "@utils/common";
import { DOCUMENT_VIEWER_LICENSE_KEY } from "@/constants";

interface IBillBookletModalPdfViewerProps {
  data: string;
}

export const BillBookletModalPdfViewer: React.FC<
  IBillBookletModalPdfViewerProps
> = (props) => {
  const { data } = props;

  const viewer = useRef<HTMLDivElement>(null);
  const instance = useRef();
  // Hack to handle race condition, where instance ref is not set, but data is already fetched
  const [instanceChangeTracker, setInstanceChangeTracker] = useState(0);

  /* eslint-disable */
  useEffect(() => {
    WebViewer(
      {
        path: "/pdfjs",
        licenseKey: DOCUMENT_VIEWER_LICENSE_KEY,
        disabledElements: [
          "header",
          "pageNavOverlay",
          "toolsOverlay",
          "contextMenuPopup",
        ],
      },
      viewer.current,
      // @ts-expect-error - cc
    ).then((inst) => {
      instance.current = inst;
      setInstanceChangeTracker((prev) => prev + 1);

      const { documentViewer } = inst.Core;
      const iframeDoc = inst.UI.iframeWindow.document;
      const FitMode = inst.UI.FitMode;

      iframeDoc
        ?.querySelector(".App")
        ?.setAttribute("style", "background: transparent;");

      documentViewer.addEventListener("documentLoaded", () => {
        inst.UI.setFitMode(FitMode.FitWidth);
      });
    });
  }, []);
  /* eslint-enable */

  useEffect(() => {
    // @ts-expect-error - cc
    // eslint-disable-next-line
    instance.current?.loadDocument(new Blob([base64ToArrayBuffer(data)]));
  }, [data, instanceChangeTracker]);

  return <div ref={viewer} className="h-[80vh] w-full"></div>;
};
